import { Skill } from '../../../../../adl-gen/totalinteraction/futurefit/db';
import { ListEntryWithIdentity, ListFieldInfo } from '../../../common/list/list-types';

export type SkillListEntry = ListEntryWithIdentity<Skill>;

export const SkillListView: ListFieldInfo<SkillListEntry, undefined>[] = [
  {
    name: 'name',
    label: 'Name',
    kind: 'i18nTextLink',
    displayed: true,
    sortable: true
  },
  {
    name: 'definition',
    label: 'Definition',
    kind: 'i18nText',
    displayed: true,
    sortable: true
  },
  {
    name: 'ordering',
    label: 'Ordering',
    kind: 'text',
    displayed: true,
    sortable: true
  }
];



// WEBPACK FOOTER //
// ./src/admin/ui/components/lists/skill-lists/skill-list-view.ts